import { makeVar } from '@apollo/client';
import { useReactiveVar } from '@apollo/client/react';
import React from 'react';

import { BURGER_MENU_TYPE } from '../layout/navigation-header/constants/header-navigation-constants';

type BurgerMenuState = {
  burgerMenuType: BURGER_MENU_TYPE;
  burgerMenuTitle: string;
  selectedNavigationMenuId?: string;
  selectedDepartmentId?: string;
  selectedDepartmentCategoryId?: string;
  selectedDepartmentName?: string;
};

export const DEFAULT_BURGER_MENU_TITLE = 'Browse';

export const defaultBurgerMenuStateVar: BurgerMenuState = {
  burgerMenuType: BURGER_MENU_TYPE.HOME,
  burgerMenuTitle: DEFAULT_BURGER_MENU_TITLE,
};

export const burgerMenuStateVar = makeVar<BurgerMenuState>(
  defaultBurgerMenuStateVar
);

export const useUpdateBurgerMenuState = () => {
  const burgerMenuState = useReactiveVar(burgerMenuStateVar);

  return (newState: Partial<BurgerMenuState>) => {
    burgerMenuStateVar({
      ...burgerMenuState,
      ...newState,
    });
  };
};

export const resetBurgerMenuState = () => {
  burgerMenuStateVar(defaultBurgerMenuStateVar);
};

/* refs */

export const burgerMenuBackButtonRef = React.createRef<HTMLButtonElement>();
export const focusBurgerMenuBackButton = () => {
  burgerMenuBackButtonRef.current?.focus();
};

export const burgerMenuCloseButtonRef = React.createRef<HTMLButtonElement>();

export const burgerMenuContentRef = React.createRef<HTMLDivElement>();
export const burgerMenuScrollToTop = () => {
  burgerMenuContentRef.current?.scrollTo(0, 0);
};
